import { render, staticRenderFns } from "./integration-info-edit-tab.vue?vue&type=template&id=cd163960&scoped=true"
import script from "./integration-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./integration-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./integration-info-edit-tab.vue?vue&type=style&index=0&id=cd163960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd163960",
  null
  
)

export default component.exports